/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteDemoDataInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteDemoDataMutationVariables = {|
  input: DeleteDemoDataInput
|};
export type deleteDemoDataMutationResponse = {|
  +deleteDemoData: ?{|
    +company: ?{|
      +id: string,
      +hasDemoData: ?boolean,
    |}
  |}
|};
export type deleteDemoDataMutation = {|
  variables: deleteDemoDataMutationVariables,
  response: deleteDemoDataMutationResponse,
|};
*/


/*
mutation deleteDemoDataMutation(
  $input: DeleteDemoDataInput!
) {
  deleteDemoData(input: $input) {
    company {
      id
      hasDemoData
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteDemoDataInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDemoDataPayload",
    "kind": "LinkedField",
    "name": "deleteDemoData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDemoData",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDemoDataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDemoDataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteDemoDataMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDemoDataMutation(\n  $input: DeleteDemoDataInput!\n) {\n  deleteDemoData(input: $input) {\n    company {\n      id\n      hasDemoData\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5eb422f25119a07b290df0ac679f426a';

module.exports = node;
